import http from "./HttpService";

const endpoint = process.env.VUE_APP_INTERVIEW_RESERVE_URL + "/api";

const getAgents = () => {
  return http.get('/admin/agents', {
    baseURL: endpoint
  });
};

const getAgent = (id) => {
  return http.get(`/admin/agents/${id}`, {
    baseURL: endpoint
  });
};

const addAgent = (id, name, mobile) => {
  return http.post('/admin/agents',
    {
      id: id,
      name: name,
      mobile: mobile,
    },
    {
      baseURL: endpoint
    }
  );
};

const editAgent = (id, name, mobile, status) => {
  return http.put(`/admin/agents/${id}`,
    {
      name: name,
      mobile: mobile,
      status: status,
    },
    {
      baseURL: endpoint,
    }
  );
};

const changeStatus = (id, status) => {
  return http.put(`/admin/agents/${id}`,
    {
      status: status,
    },
    {
      baseURL: endpoint,
    }
  );
};

export default {getAgents, getAgent, addAgent, editAgent, changeStatus};
